"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _react = _interopRequireWildcard(require("react")),
    _Uploader = require("../../Uploader"),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _CommentsProvider = _interopRequireDefault(require("../components/CommentsProvider")),
    _api = require("../api");

function CommentProvider(a, b) {
  var c = a.resourceId,
      d = a.resourceOrganisationId,
      e = a.children,
      f = a.modalTarget,
      g = a.filterByMetadataFlag,
      h = a.isReadOnly,
      i = a.canResolveComment,
      j = a.onCommentAssetsChange;
  return _react["default"].createElement(_Uploader.UploaderConsumer, null, function (a) {
    var k = a.fetchAssets;
    return _react["default"].createElement(_RequestProvider["default"], {
      requests: {
        getCommentsRequest: (0, _api.getCommentsApi)(),
        updateCommentRequest: (0, _api.updateCommentApi)(),
        createCommentRequest: (0, _api.createCommentApi)(),
        deleteCommentRequest: (0, _api.deleteCommentApi)(),
        updateViewersRequest: (0, _api.updateViewersApi)()
      }
    }, function (a) {
      return _react["default"].createElement(_CommentsProvider["default"], (0, _extends2["default"])({
        resourceId: c,
        resourceOrganisationId: d,
        fetchAssets: k,
        modalTarget: f,
        filterByMetadataFlag: g,
        isReadOnly: h,
        canResolveComment: i,
        onCommentAssetsChange: j,
        ref: b
      }, a), e);
    });
  });
}

var _default = (0, _react.forwardRef)(CommentProvider);

exports["default"] = _default;